import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
`

export const ColorBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: ${({ color }) => color || '#CCCCCC'};
  outline: ${({ selected }) => (
    selected ? '2px solid #FFC100' : '1px solid #CCCCCC'
  )};
  cursor: pointer;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  width: 200px;
  align-self: center;
`

export const DangerButton = styled(Button).attrs ({
  type: 'button'
})`
  background-color: #FF3939;

  &:hover {
    background-color: #FF2020;
    color: #FFFFFF;
  }
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`